import React from "react";
import { useParams } from "react-router-dom";
import { CreditAuthorizationForm } from "@/components/CreditAuthorizationForm/CreditAuthorizationForm";
import { CreditAuthorizationDisclaimer } from "@/components/CreditAuthorizationDisclaimer/CreditAuthorizationDisclaimer";

export const CreditAuthorizationPage: React.FC = () => {
  const { creditAuthorizationId } = useParams<{ creditAuthorizationId: string }>();

  if (!creditAuthorizationId) {
    return (
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "30px", color: "#333" }}>
          Credit Authorization & Consent
        </h1>
        <div style={{ color: "#dc3545", textAlign: "center" }}>
          Invalid credit authorization ID
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "30px", color: "#333" }}>
        Credit Authorization & Consent
      </h1>
      
      <CreditAuthorizationDisclaimer />
      
      <CreditAuthorizationForm creditAuthorizationId={creditAuthorizationId} />
    </div>
  );
};
